import { StyleSheet, View } from 'react-native';

import { useCRMEventsContext } from '@fhs/auth/src/hooks';
import { Text, tokens } from '@fhs/ui';
import { LOYALTY_SAVINGS } from '@fhs-legacy/frontend/src/utils/test-ids';

import { logCheckoutDiscountNotApplied } from '../../utils/logging-utils';

import CashSignIcon from './cash-sign-icon';

export default function SavingsWithOffer({
  savings,
  onCheckout = false,
  loadingSavings = false,
}: {
  savings: number;
  onCheckout?: boolean;
  loadingSavings?: boolean;
}) {
  const { logRBIEvent } = useCRMEventsContext();

  if (loadingSavings) {
    return (
      <View
        testID={LOYALTY_SAVINGS}
        style={onCheckout ? styles.checkoutContainer : styles.container}
        accessibilityRole="text"
        accessibilityLabel="Calculating savings"
        accessibilityLiveRegion="polite"
      >
        <CashSignIcon variant={onCheckout ? 'green' : 'white'} />
        <Text style={styles.textColor}>
          Calculating savings...
        </Text>
      </View>
    );
  }
  if (savings === 0) {
    logCheckoutDiscountNotApplied(logRBIEvent);
  }

  const savingsAmount = (savings / 100).toFixed(2);

  return (
    <View
      testID={LOYALTY_SAVINGS}
      style={[styles.container, onCheckout && styles.checkoutContainer]}
      accessibilityRole="text"
      accessibilityLabel={`Saving ${savingsAmount} With Firehouse Rewards`}
      accessibilityLiveRegion="polite"
    >
      <CashSignIcon variant={onCheckout ? 'green' : 'white'} />
      <Text style={styles.textColor}>
        Saving{' '}
        <Text
          weight="semibold"
          style={styles.textColor}
        >
          ${savingsAmount}{' '}
        </Text>
        With Firehouse Rewards
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: tokens.colors.$success,
    height: 49,
    flexDirection: 'row',
    gap: 4,
    alignItems: 'center',
    justifyContent: 'center',
  },
  checkoutContainer: {
    marginTop: 16,
  },
  textColor: {
    color: 'white',
  },
  skeleton: {
    height: 16,
    width: 33,
    borderRadius: 4,
    marginTop: 4,
  },
});
